"use client"

import {ThemeProvider} from "next-themes"
import type {ReactNode} from "react"

/**
 * Theme plumbing. `attribute="class"` is what the token layer expects — every
 * dark override in app.css hangs off `.dark` via the @custom-variant.
 *
 * Unlike dized-next (dark-only by product decision), the portal follows the
 * publisher's OS preference: it is a work tool sitting next to other work
 * tools, and defaulting a spreadsheet-adjacent UI to black surprises people.
 */
export const Providers = ({children}: {children: ReactNode}) => (
  <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
    {children}
  </ThemeProvider>
)
